import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Autocomplete from '../../../Utilities/Autocomplete';
import KPIManageService from '../../../Service/KPIManageService';
import Swal from 'sweetalert2';

class FormManageCopyProject extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            canUpdate: false,
            KPICopy: {},
            loading: false
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.show === false && this.state.canUpdate === false) {
            return false;
        }
        return true;
    }

    onHideModal = () => {
        this.props.hide(this.resetState);
    }

    onEnterModal = () => {
        this.setState({ canUpdate: true });
    }

    searchKPI = (KPIName) => {
        return KPIManageService.searchKPIWithProject(KPIName);
    }

    resetState = () => {
        this.setState({
            canUpdate: false,
            KPICopy: {},
            loading: false
        })
    }

    onChangeContent = (name, value) => {
        this.setState({ [name]: value }, () => {
            console.log(this.state)
        });
    }

    onSave = () => {
        if (!this.state.KPICopy || !this.state.KPICopy.KPIID) {
            Swal.fire({
                type: 'warning',
                title: 'กรุณาเลือกตัวชี้วัด',
                text: 'กรุณาเลือกตัวชี้วัดที่ต้องการคัดลอก'
            });
            return;
        }
        Swal.fire({
            title: 'คัดลอกโครงการของตัวชี้วัด',
            text: 'ท่านต้องการโครงการของคัดลอกตัวชี้วัด "' + this.state.KPICopy.KPIName + '" หรือไม่ ?',
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
            reverseButtons: true
        })
            .then(res => {
                if (res.value) {
                    this.setState({ loading: true }, () => {
                        KPIManageService.getKPIDetail(this.state.KPICopy.KPIID)
                            .then(result => {
                                result = result.data.GetKPIDetail;
                                console.log(result);
                                this.props.copyProject(result.ProjectKPI, () => {
                                    this.setState({ loading: false }, () => {
                                        this.onHideModal();
                                    });
                                });
                            })
                            .catch(e => {
                                console.log(e);
                                this.onHideModal();
                            })
                    })
                }
            })
    }

    render() {
        return (
            <>
                <Modal
                    show={this.props.show}
                    onHide={(this.state.loading) ? null : this.onHideModal}
                    size='lg'
                    onEnter={this.onEnterModal}
                    backdropClassName='backdrop-formcopy'
                    className='dialog-formcopy'
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            คัดลอกโครงการ
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {/* <Autocomplete
                            getData={this.searchForm}
                            name='formToCopy'
                            labelName='แบบฟอร์ม'
                            dataName='Form'
                            listName='ListForm'
                            onChangeSelect={this.onChangeContent}
                            selectValue={this.state.formToCopy}
                            searchOnChange
                        /> */}
                        <Autocomplete
                            getData={this.searchKPI}
                            name='KPICopy'
                            labelName='ตัวชี้วัด'
                            dataName='KPI'
                            listName='ListKPI'
                            onChangeSelect={this.onChangeContent}
                            selectValue={this.state.KPICopy}
                            searchOnChange
                        />
                    </Modal.Body>

                    <Modal.Footer>
                        <div className='float-right'>
                            {
                                (this.state.loading) ?
                                    <button className='btn btn-outline-primary' disabled>
                                        <i className='fa fa-circle-o-notch fa-spin mr-2' />
                                        กำลังทำรายการ
                                    </button>
                                    :
                                    <>
                                        <button className='btn btn-outline-danger mr-2' onClick={this.onHideModal}>ยกเลิก</button>
                                        <button
                                            className='btn btn-outline-primary'
                                            onClick={this.onSave}
                                        >
                                            ตกลง
                                </button>
                                    </>
                            }
                        </div>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default FormManageCopyProject;
